import React from "react";

interface FormSectionCardProps {
  children: React.ReactNode;
  className?: string;
}

export const FormSectionCard: React.FC<FormSectionCardProps> = ({
  children,
  className = "",
}) => {
  return (
    <div
      className={`p-4 bg-card rounded-lg border border-gray-200 shadow-sm ${className}`}
    >
      {children}
    </div>
  );
};
